// extracted by mini-css-extract-plugin
export default {"container":"DU-z","title":"EU-z","link":"FU-z"};